import { Button, Modal } from "@mantine/core";
import { useState } from "react";
import { generatePath } from "react-router";
import { usePersons } from "../../../hooks/usePersons";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import urls from "../../../urls";
import { type Todo, type User } from "../../../utils/backend-types";
import { LoadOrError } from "../../LoadOrError/LoadOrError";
import { TodoForm } from "../TodoForm/TodoForm";
import { CATEGORIES } from "../Todos.constants";
import type { Mode } from "../Todos.types";
import "./EditTodoModal.scss";

interface EditTodoModalProps {
  isOpen: boolean;
  onToggle: () => void;
  todo: Todo;
  users: Array<User>;
  variantId: number;
  projectId: string;
  mode: Mode;
  basePath: string;
}

function EditTodoModal({
  isOpen,
  onToggle,
  todo,
  users,
  variantId,
  projectId,
  mode,
  basePath
}: EditTodoModalProps) {
  const {
    persons,
    isLoading: personsLoading,
    error: personsError
  } = usePersons({ variantId });
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleSubmit(data: Todo) {
    document.location.href = `${generatePath(basePath, {
      projectId: projectId
    })}/${data.id}/`;
  }

  const patchUrl = urls.api.todosDetail(todo.id);
  const disableLabelEdit =
    todo.category === CATEGORIES.ONBOARDING.value && todo.systemCreated;

  return (
    <Modal
      className="EditTodoModal"
      opened={isOpen}
      size="xl"
      title="Aufgabe bearbeiten"
      onClose={onToggle}
    >
      <LoadOrError error={personsError} loading={personsLoading}>
        <TodoForm
          disableLabelEdit={disableLabelEdit}
          initialValues={todo}
          mode={mode}
          patchUrl={patchUrl}
          persons={persons}
          users={users}
          variantId={variantId}
          onSubmit={handleSubmit}
          onSubmittingChange={setIsSubmitting}
        />
      </LoadOrError>
      <ModalFooter>
        <Button variant="default" onClick={onToggle}>
          Abbrechen
        </Button>
        <Button
          color="secondary"
          disabled={personsLoading}
          form="todo-form"
          loading={isSubmitting}
          type="submit"
        >
          Speichern
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { EditTodoModal };
